<smrts-page primaryTitle="Gerenciar Perfis de Usuários">

  <div header class="header inline-element">
    <p-floatLabel variant="on" class="busca-usuario-field">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
        <input pInputText id="buscarUsuario" class="busca-usuario-input" (input)="listaUsuarios.filtrar($any($event.target).value);editarPapeis.filtrar($any($event.target).value);editarPermissoes.filtrar($any($event.target).value);" />
      </p-iconField>
      <label for="buscarUsuario">Buscar</label>
    </p-floatLabel>
  </div>

  <div class="content">
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">Usuários</p-tab>
      <p-tab value="1">Papéis dos Usuários</p-tab>
      <p-tab value="2">Permissões dos Papéis</p-tab>
    </p-tablist>
    <p-tabpanels class="tabpanels">
      <p-tabpanel class="tabpanel" value="0">
        <app-lista-usuarios #listaUsuarios [usuarios]="usuarios" (usuariosChange)="usuarios = $event"></app-lista-usuarios>
      </p-tabpanel>
      <p-tabpanel class="tabpanel" value="1">
        <app-editar-papeis-usuario class="editar-painel" #editarPapeis [usuarios]="usuarios" [papeis]="papeis" (usuariosChange)="usuarios = $event" (papeisChange)="papeis = $event"></app-editar-papeis-usuario>
      </p-tabpanel>
      <p-tabpanel class="tabpanel" value="2">
        <app-editar-permissoes-papel class="editar-painel" #editarPermissoes [papeis]="papeis" [permissoes]="permissoes" (papeisChange)="papeis = $event"></app-editar-permissoes-papel>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  </div>

</smrts-page>
